import firebase from "../../Firebase.js";
const firebaseStorage = firebase.storage();

const handleChangeSwift = (
  info,
  fileListSw,
  secondaryFileListSw,
  handleState,
  handleLoading
) => {
  handleState(fileListSw, secondaryFileListSw, info);

  if (info.file.status === "uploding") {
    handleLoading(true);
  }

  if (info.file.status === "done") {
    handleLoading(false);
  }
};

const customUploadSwift = async ({
  onError,
  onSuccess,
  file,
  folder,
  stateList,
  nameState,
  notification,
  handleUploadfile,
}) => {
  const allowedTypes = {
    "application/pdf": ".pdf",
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "image/tiff": ".tiff",
    "image/bmp": ".bmp",
    "image/gif": ".gif",
  };

  const extensionFromType = allowedTypes[file.type];
  const hasExtensionInName = file.name.includes(".");
  let finalFileName = file.name;

  // 1. Validate if the file type is allowed (MIME Type)
  if (!extensionFromType) {
    const msg = {
      message: `El archivo: ${file.name} no es un formato válido. Use PDF o imágenes (JPG, PNG, TIFF).`,
      top: 80,
    };
    notification.error(msg);
    onError(msg);
    return;
  }

  // 2. Normalize filename: If it has no extension, append one based on its type
  if (!hasExtensionInName) {
    finalFileName = `${file.name}${extensionFromType}`;
  }

  // 3. Validation: Multiple dots in name (optional strictness as in original code)
  const totalDots = finalFileName.split(".").length - 1;
  if (totalDots > 1) {
    const msg = {
      message: `El archivo: ${file.name} no puede contener puntos adicionales en el nombre.`,
      top: 80,
    };
    notification.error(msg);
    onError(msg);
    return;
  }

  // 5. Upload process
  const storager = await firebaseStorage.ref();
  const pdfImgFile = storager.child(`${folder}/${finalFileName}`);

  // Set proper metadata for Firebase
  const metadata = {
    contentType: file.type || "application/octet-stream",
  };

  try {
    const pdfImg = await pdfImgFile.put(file, metadata);
    const url = await firebaseStorage
      .ref(folder)
      .child(finalFileName)
      .getDownloadURL();

    // Use normalized name for state (optional)
    if (handleUploadfile && nameState) {
      // We pass a simple object because File properties can be read-only
      handleUploadfile({ name: finalFileName }, nameState);
    }
    onSuccess(null, { ...pdfImg, url });
  } catch (e) {
    onError(e.message);
  }
};

export { default as propagarArchivosDeOp } from "./propagarArchivosDeOp";
export { handleChangeSwift, customUploadSwift };
